import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcInviteIcon, IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { useCopyToClipboard } from 'APP/hooks/useCopyToClipboard/useCopyToClipboard';

import { MetaBlock } from '../MetaBlock/MetaBlock';
import styles from './ProfileEmail.styles.m.css';

interface IProfileEmailProps {
  className?: string;
  email: string;
  isSendMail?: boolean;
}

export const ProfileEmail: FC<IProfileEmailProps> = observer(
  ({ className, email, isSendMail = true }) => {
    const { t } = useTranslation();
    const copyToClipboard = useCopyToClipboard(email, t('profile_user_email_copied'));

    const handleMailtoClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
      e.preventDefault();
      window.open(`mailto:${email}`);
    };

    return (
      <MetaBlock
        className={className}
        label={t('auth_email')}
        Icon={IcInviteIcon}
        Actions={
          <IconButton
            Icon={IcSCopyIcon}
            onClick={copyToClipboard}
          />
        }
      >
        {isSendMail ? (
          <button
            className={styles.link}
            onClick={handleMailtoClick}
          >
            {email}
          </button>
        ) : (
          <button
            className={styles.link}
            onClick={copyToClipboard}
            data-test="my-email"
          >
            {email}
          </button>
        )}
      </MetaBlock>
    );
  }
);
